import React, { useRef, useState } from "react";
import logo from "@assets/icons/logo.svg";
import user from "@assets/icons/user.svg";
import chevronDown from "@assets/icons/chevron.svg";
import logoutIcon from "@assets/icons/logout-icon.svg";
import styles from "./Header.module.css";
import { useNavigate } from "react-router-dom";
import { useClickOutside } from "@hooks/useClickOutside";
import { environment } from "@environments/environment";

function Header() {
  const navigate = useNavigate();
  const userMenuRef = useRef<HTMLDivElement>(null);
  const [logoutOpen, setLogoutOpen] = useState(false);
  const isLoggedIn = localStorage.getItem("accessToken") ? true : false;
  const path = location.pathname;

  const handleLogOut = () => {
    localStorage.clear();
    navigate("/");
  };
  const handleIconClick = () => {
    const roleId = localStorage.getItem("roleId");
    if (Number(roleId) === environment.ROLE_IDS.ADMIN) {
      navigate("/admin-dashboard");
      return;
    }
    if (Number(roleId) === environment.ROLE_IDS.EVALUATOR) {
      navigate("/evaluator-dashboard");
      return;
    }
    navigate("/");
  };

  useClickOutside(userMenuRef, () => setLogoutOpen(false), logoutOpen);

  return (
    <header className={styles.header}>
      <img
        src={logo}
        alt="Infinity Meta Logo"
        className={styles.logo}
        onClick={handleIconClick}
      />
      {isLoggedIn && path != "/" && (
        <div className={styles.controls}>
          <div className={styles.userMenu} ref={userMenuRef}>
            <div
              className={styles.userProfile}
              onClick={() => setLogoutOpen(!logoutOpen)}
            >
              <img src={user} alt="User Profile" className={styles.userIcon} />
              <img
                src={chevronDown}
                alt="Arrow Down"
                className={styles.chevronDown}
              />
            </div>
            {logoutOpen && (
              <div className={styles.logout} onClick={handleLogOut}>
                <img src={logoutIcon} alt="Logout" className={styles.icon} />
                <span>Logout</span>
              </div>
            )}
          </div>
        </div>
      )}
    </header>
  );
}

export default Header;
